import apiPost from '../../shared/functions/apiPost';
import { appointmentApiUrl } from '../constants/webAppointmentConstants';

export default function sendRequest(requestData) {
  return apiPost(appointmentApiUrl, requestData, null, true, "application/json", true);
}
